import { Phone, Mail, MapPin, CreditCard } from "lucide-react";

export const Footer = ({ phone, email, payLink }) => (
  <footer className="border-t border-white/10 bg-[#080808]">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <h3 className="font-serif text-5xl tracking-tight">LUXERIDE<span className="text-gold">NY</span></h3>
          <p className="mt-5 text-[#8A8A8A] font-light max-w-sm">
            Owner-operated luxury black-car service. Escalade &amp; Suburban Z71,
            serving the Hamptons, New York City and all area airports.
          </p>
        </div>

        <div className="lg:col-span-4 lg:col-start-9 space-y-5">
          <a href={`tel:${phone}`} data-testid="footer-phone" className="flex items-center gap-4 group">
            <Phone className="w-4 h-4 text-gold" />
            <span className="text-lg group-hover:text-gold transition-colors">{phone}</span>
          </a>
          <a href={`mailto:${email}`} data-testid="footer-email" className="flex items-center gap-4 group break-all">
            <Mail className="w-4 h-4 text-gold" />
            <span className="group-hover:text-gold transition-colors">{email}</span>
          </a>
          <div className="flex items-center gap-4">
            <MapPin className="w-4 h-4 text-gold" />
            <span className="text-[#8A8A8A]">Hamptons · New York · Tri-State</span>
          </div>
          <a
            href="sms:+15162622059?&body=Hi%20LUXERIDENY%2C%20I%27d%20like%20to%20pay%20my%20fare."
            data-testid="footer-pay-btn"
            className="inline-flex items-center gap-2 bg-gold text-black px-6 py-3 w-max mt-2 hover:bg-gold-hover transition-colors duration-400"
          >
            <CreditCard className="w-4 h-4" />
            <span className="overline text-black">Text to Pay</span>
          </a>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4">
        <p className="overline text-[#8A8A8A]">© {new Date().getFullYear()} LuxeRideNY</p>
        <div className="flex items-center gap-8">
          <a href="/legal" data-testid="footer-legal-link" className="overline text-[#8A8A8A] hover:text-gold transition-colors">Terms &amp; Privacy</a>
          <a href="/admin" className="overline text-[#8A8A8A] hover:text-gold transition-colors">Operator Login</a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
